import TextField from "../../../components/molecules/TextField/TextField"
import { loc } from "../../../core/utils"
import PassworErrorMessageHandler from "./PasswordErrorMessageHandler"
import validate from "./validate"
import React from "react"
import { Button, Form } from "react-bootstrap"
import * as FinalForm from "react-final-form"

function ResetPasswordForm({ onSubmit }) {
  return (
    <FinalForm.Form
      validate={validate}
      onSubmit={onSubmit}
      render={({ values, form, handleSubmit, hasValidationErrors, errors }) => {
        return (
          <Form onSubmit={handleSubmit} className="d-flex flex-column">
            <TextField type="password" aria-label="oldPassword" name="oldPassword" label={loc("old_password")} />
            <TextField type="password" aria-label="newPassword" name="newPassword" label={loc("new_password")} />
            <TextField
              type="password"
              aria-label="verifyNewPassword"
              name="verifyNewPassword"
              label={loc("verify_new_password")}
            />
            <Button type="submit" className="mb-2" disabled={hasValidationErrors}>
              {loc("change_password")}
            </Button>
            {values?.newPassword && (
              <PassworErrorMessageHandler values={values} errors={errors} hasValidationErrors={hasValidationErrors} />
            )}
          </Form>
        )
      }}
    />
  )
}

export default ResetPasswordForm
